export default "__VITE_ASSET__OoOu8HNF__"